import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';

@ValidatorConstraint({ name: 'isTrue', async: false })
export class IsTrueConstraint implements ValidatorConstraintInterface {
  validate(value: any, args: ValidationArguments) {
    return value === true;
  }

  defaultMessage(args: ValidationArguments) {
    // Customize the error message here
    return `${args.property} must be true.`;
  }
}

export function IsTrue(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: IsTrueConstraint,
    });
  };
}
